import { render, staticRenderFns } from "./AddWeights.vue?vue&type=template&id=eef8d89c&scoped=true"
import script from "./AddWeights.vue?vue&type=script&lang=ts"
export * from "./AddWeights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef8d89c",
  null
  
)

export default component.exports